import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import ReactHtmlParser from "react-html-parser";
import Button from "@material-ui/core/Button";
import Link from "../../Link";
import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

export const CoreButtonBlock = (props) => {
  const classes = useStyles();
  let variant = "contained";

  let attributes = props.attributes;
  if (props.attributes === null || typeof(props.attributes.text) === 'undefined') {
    attributes = JSON.parse(props.attributesJSON);
  }

  if (typeof attributes.className !== "undefined" && attributes.className !== null) {
    if (attributes.className.indexOf("is-style-outline") !== -1) variant = "outlined";
  }

  if (attributes.url == "" && attributes.text == "")
    return null;

  return (
    <Link
      to={attributes.url}
      style={{ textDecoration: "none" }}
      className={classes.root}
      state={attributes?.linkState}
    >
    <Button
      variant={variant}
        title={attributes?.title}
        className={`${attributes?.className} ${attributes?.textColor}`}
        data-text-color={
          attributes?.textColor !== null
            ? attributes?.textColor
            : "initial"
        }
        data-bg-color={
          attributes?.backgroundColor !== null
            ? attributes?.backgroundColor
            : "initial"
        }
    >
        {ReactHtmlParser(attributes?.text)}
    </Button>
  </Link>
  );
};

CoreButtonBlock.propTypes = {
    attributes: PropTypes.object.isRequired,
};

export const CoreButtonBlockFragment = graphql`
  fragment CoreButtonBlock on WpBlock {
    ... on WpCoreButtonBlock {
      name
      attributesJSON
      attributes {
        __typename
       ... on WpCoreButtonBlockAttributes {
          backgroundColor
          className
          gradient
          linkTarget
          placeholder
          rel
          text
          textColor
          title
          url
        }
      }
    }
  }
`;

  // This is the string version of this that is used within previews and without WP prefixes
export const CoreButtonBlockPreview = `
... on CoreButtonBlock {
  name
  attributesJSON
  attributes {
    __typename
   ... on CoreButtonBlockAttributes {
      backgroundColor
      className
      gradient
      linkTarget
      placeholder
      rel
      text
      textColor
      title
      url
    }
  }
}
`;
